<template>
  <div>
    <h1 class="page-header">Card Profile</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-4 col-form-label control-label"
                  >Customer Name<span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <ts-search-select v-model="model.customer_id" :options="customers" @change="customerSelected">
                  </ts-search-select>
                  <div class="invalid" v-if="errors.has('customer_id')">
                    {{ errors.first('customer_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-4 col-form-label control-label">Card Type<span class="text-danger">*</span></label>
                <div class="col-md-7">
                  <ts-search-select v-model="model.card_type_id" :options="cardTypes"> </ts-search-select>
                  <div class="invalid" v-if="errors.has('card_type_id')">
                    {{ errors.first('card_type_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-4 col-form-label control-label"
                  >Serial Card<span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <input
                    v-model="model.serial_card"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('serial_card') }"
                    placeholder="Enter serial card"
                  />
                  <div class="invalid-feedback" v-if="errors.has('serial_card')">
                    {{ errors.first('serial_card') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-4 col-form-label control-label"
                  >Effective Date<span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <ts-date-picker-input v-model="model.effective_date"></ts-date-picker-input>
                  <div class="invalid" v-if="errors.has('effective_date')">
                    {{ errors.first('effective_date') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-4 col-form-label control-label"
                  >Expired Date<span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <ts-date-picker-input v-model="model.expiry_date"></ts-date-picker-input>
                  <div class="invalid" v-if="errors.has('expiry_date')">
                    {{ errors.first('expiry_date') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <h6 class="mt-2" style="color:#cacaca;">CUSTOMER INFORMATION</h6>
              <hr />
              <div class="row form-group m-b-15 pl-3">
                <label class="col-md-5 col-form-label control-label">Gender</label>
                <div class="col-md-7">
                  <input type="text" :value="customerInfor.gender" class="form-control-plaintext" readonly />
                </div>
              </div>
              <div class="row form-group m-b-15 pl-3">
                <label class="col-md-5 col-form-label control-label">Phone Number</label>
                <div class="col-md-7">
                  <input type="text" :value="customerInfor.contact_no" class="form-control-plaintext" readonly />
                </div>
              </div>
              <div class="row form-group m-b-15 pl-3">
                <label class="col-md-5 col-form-label control-label">Email Address</label>
                <div class="col-md-7">
                  <input type="text" :value="customerInfor.email" class="form-control-plaintext" readonly />
                </div>
              </div>
              <div class="row form-group m-b-15 pl-3">
                <label class="col-md-5 col-form-label control-label">
                  Description
                </label>
                <div class="col-md-7">
                  <textarea class="form-control-plaintext" rows="3" readonly v-model="customerInfor.description">
                  </textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 text-right">
              <hr />
              <ts-button class="btn-primary" :waiting="saveNew" @click.prevent="saveAddNew">Save Add New</ts-button>
              <ts-button class="btn-primary ml-2" :waiting="save" @click.prevent="store">Save</ts-button>
              <ts-button class="ml-2" @click="$router.push({ name: 'card-profile' })">Cancel</ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'card-profile-create',
  data() {
    return {
      model: {
        customer_id: '',
        serial_card: '',
        card_type_id: '',
        effective_date: moment().format('DD-MM-YYYY'),
        expiry_date: moment().format('DD-MM-YYYY')
      },
      customerInfor: {
        customer_id: '',
        customer_name: 'N/A',
        gender: 'N/A',
        contact_no: 'N/A',
        email: 'N/A',
        description: 'N/A'
      },
      errors: new Errors(),
      saveNew: false,
      save: false
    }
  },
  created() {},
  computed: {
    customers() {
      return this.$store.state.administration.cardProfile.customers.map(el => ({
        value: el.customer_id,
        text: el.customer_name
      }))
    },
    cardTypes() {
      return this.$store.state.administration.cardProfile.cardTypes.map(el => ({
        value: el.card_type_id,
        text: el.card_type
      }))
    }
  },
  methods: {
    customerSelected() {
      let customer = this.$store.state.administration.cardProfile.customers.filter(
        cus => cus.customer_id == this.model.customer_id
      )
      if (customer.length > 0) {
        this.customerInfor = customer[0]
      }
    },
    store() {
      this.errors = new Errors()
      this.save = true
      this.$store
        .dispatch('administration/cardProfile/store', this.model)
        .then(response => {
          this.save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'card-profile' })
        })
        .catch(error => {
          this.save = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.saveNew = true
      this.$store
        .dispatch('administration/cardProfile/store', this.model)
        .then(response => {
          this.saveNew = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.saveNew = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput() {
      this.model = {
        customer_id: '',
        serial_card: '',
        card_type_id: '',
        effective_date: moment().format('DD-MM-YYYY'),
        expiry_date: moment().format('DD-MM-YYYY')
      }
      this.customerInfor = {
        customer_id: '',
        customer_name: 'N/A',
        gender: 'N/A',
        contact_no: 'N/A',
        email: 'N/A',
        description: 'N/A'
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('administration/cardProfile/RESET_STATE')
    }
    next()
  }
}
</script>
<style lang="css">
hr {
  margin-top: 0rem !important;
}
</style>
